module.exports = __webpack_public_path__ + "img/avatar-43.25cfa091.png";